import {Settings2} from 'lucide-react';
import {Dialog,DialogContent,DialogDescription,DialogHeader,DialogTitle,DialogTrigger} from '@/components/ui/dialog';
import {SettingsLayoutContext} from '@/components/SettingsSection';
const widths={small:'sm:max-w-sm',medium:'sm:max-w-xl',large:'sm:max-w-3xl'};

export default function SettingsPanel({open,onOpenChange,title,subtitle,children,id,status,size,footer}){
 return <Dialog open={open} onOpenChange={onOpenChange}>
  <DialogTrigger asChild><button id={id} type="button" className="tps-settings-trigger"><span className="min-w-0"><span className="block font-semibold">{title}</span>{subtitle&&<span className="mt-1 block text-xs text-muted-foreground">{subtitle}</span>}{status&&<span className="mt-2 block">{status}</span>}</span><Settings2 aria-hidden="true" className="h-4 w-4 shrink-0 text-muted-foreground"/></button></DialogTrigger>
  <DialogContent className={`tps-settings-dialog ${widths[size]||widths.medium}`}>
   <DialogHeader className="pr-6 text-left"><DialogTitle>{title}</DialogTitle>{subtitle&&<DialogDescription>{subtitle}</DialogDescription>}</DialogHeader>
   <SettingsLayoutContext.Provider value={null}><div className="tps-settings-body">{children}</div></SettingsLayoutContext.Provider>
   {footer&&<div className="tps-settings-footer">{footer}</div>}
  </DialogContent>
 </Dialog>;
}
